import { render, staticRenderFns } from "./ShowOrderById.vue?vue&type=template&id=c38a5c36"
import script from "./ShowOrderById.vue?vue&type=script&lang=js"
export * from "./ShowOrderById.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports